// WhatsApp Configuration
export const whatsappConfig = {
  // Default phone number (will be overridden by tenant data)
  phoneNumber: '1234567890',
  
  // Default message that will be pre-filled when user clicks the button
  defaultMessage: 'Hello! I would like to book an appointment with your dental clinic.',
  
  // You can customize the tooltip text
  tooltipText: 'Chat with us on WhatsApp',
  
  // Button position (optional - can be customized in SCSS)
  position: {
    bottom: '20px',
    right: '20px'
  }
};

// Helper function to get the WhatsApp URL
export const getWhatsAppUrl = (customMessage = null, phoneNumber = null) => {
  const message = customMessage || whatsappConfig.defaultMessage;
  const number = phoneNumber || whatsappConfig.phoneNumber;
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
};

// Function to update WhatsApp config with tenant data
export const updateWhatsAppConfig = (tenantData) => {
  if (tenantData) {
    // Priority: whatsapp_number field > frontend_data.contact_info.whatsapp > phone_number
    let whatsappNumber = tenantData.whatsapp_number || 
                        tenantData.frontend_data?.contact_info?.whatsapp || 
                        tenantData.phone_number;
    
    if (whatsappNumber) {
      // Remove any non-digit characters and ensure it starts with country code
      const cleanNumber = whatsappNumber.replace(/\D/g, '');
      whatsappConfig.phoneNumber = cleanNumber;
    }
  }
};

// Function to get WhatsApp number from tenant data
export const getWhatsAppNumber = (tenantData) => {
  if (!tenantData) return whatsappConfig.phoneNumber;
  
  // Priority: whatsapp_number field > frontend_data.contact_info.whatsapp > phone_number
  return tenantData.whatsapp_number || 
         tenantData.frontend_data?.contact_info?.whatsapp || 
         tenantData.phone_number || 
         whatsappConfig.phoneNumber;
}; 